export default "__VITE_ASSET__CA6jDv77__"